import React, { useState, useCallback, useRef, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import Toolbar, { Item } from "devextreme-react/toolbar";
import PrimaryTab from "./tabs/PrimaryTab";
import DetailsTab from "./tabs/DetailsTab";
import axios from "axios";
import data from "../../../../assets/apiRoutes.json";
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

function Form(props) {
    const history = useHistory();
    const formRefs = useRef({});
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        RECORD: '',
        R_PROFILE: '',
        R_CUSTOMER: '',
        KITTCODE: '',
        DESCRIPTION: '',
        COMMENT: '',
        STATUS: 'A'
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const accessToken = props?.oidc?.user?.access_token;

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const position = { of: '#accordion' };

    const handleFieldChange = useCallback((name, value) => {
        setformFields(prevFields => ({
            ...prevFields,
            [name]: value
        }));
    }, []);

    const loadItemKitHeaderById = useCallback(async (rowId) => {
        if (!rowId || rowId === '00000000-0000-0000-0000-000000000000') {
            return;
        }

        try {
            setLoadPanelVisible(true);
            const url = `${window._env_.REACT_APP_APIS}/${data.ItemKitHeader.GetItemKitHeader}?rowid=${rowId}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

                if (response.data) {
                    const itemKitHeader = response.data;
                    setformFields({
                        ROWID: itemKitHeader.RowId || initialFormFields.ROWID,
                        RECORD: itemKitHeader.RecordNumber || '',
                        R_PROFILE: itemKitHeader.RProfile || '',
                        R_CUSTOMER: itemKitHeader.RCustomer || '',
                        KITTCODE: itemKitHeader.KittCode || '',
                        DESCRIPTION: itemKitHeader.Description || '',
                        COMMENT: itemKitHeader.Comment || '',
                        STATUS: itemKitHeader.Status || 'A'
                    });
                }
        } catch (error) {
            console.error('Error loading Item Kit Header:', error);
            notify('Failed to load Item Kit Header data.', 'error', 3000);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    useEffect(() => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadItemKitHeaderById(rowId);
        }
    }, [props.id, loadItemKitHeaderById]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsFormSubmitted(true);
        setLoadPanelVisible(true);

        try {
            const payload = {
                RowId: formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000" ? formFields.ROWID : "00000000-0000-0000-0000-000000000000",
                KeySequence: 0,
                RProfile: formFields.R_PROFILE || null,
                RCustomer: formFields.R_CUSTOMER || null,
                KittCode: formFields.KITTCODE || "",
                Description: formFields.DESCRIPTION || "",
                Comment: formFields.COMMENT || "",
                Status: formFields.STATUS || "A"
            };

            // Determine if this is an insert or update based on ROWID
            const isUpdate = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
            const endpoint = isUpdate ? data.ItemKitHeader.UpdateItemKitHeader : data.ItemKitHeader.InsertItemKitHeader;
            const method = isUpdate ? 'put' : 'post';
            
            const url = `${window._env_.REACT_APP_APIS}/${endpoint}`;
            const resp = await axios[method](url, payload, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                }
            });

            const saved = resp?.data;
            if (saved) {
                setformFields((prev) => ({
                    ...prev,
                    ROWID: saved.RowId || prev.ROWID,
                    RECORD: saved.RecordNumber || prev.RECORD,
                    R_PROFILE: saved.RProfile || prev.R_PROFILE,
                    R_CUSTOMER: saved.RCustomer || prev.R_CUSTOMER,
                    KITTCODE: saved.KittCode || prev.KITTCODE,
                    DESCRIPTION: saved.Description || prev.DESCRIPTION,
                    COMMENT: saved.Comment || prev.COMMENT,
                    STATUS: saved.Status || prev.STATUS
                }));
            }

            notify("Item Kit Header saved successfully.", "success", 3000);
        } catch (err) {
            const message =
                err?.response?.data?.message ||
                (typeof err?.response?.data === "string" ? err.response.data : null) ||
                err?.message ||
                "Failed to save Item Kit Header.";

            notify(message, "error", 5000);
        } finally {
            hideLoadPanel();
            setIsFormSubmitted(false);
        }
    };

    const addNewRecordClick = () => {
        setformFields(initialFormFields);
    };

    const DeleteClick = () => {
        if (!formFields.ROWID || formFields.ROWID === "00000000-0000-0000-0000-000000000000") {
            notify("No record selected for deletion.", "warning", 3000);
            return;
        }

        let result = confirm("<i>Are you sure you want to delete this Item Kit Header?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try {
                    const url = `${window._env_.REACT_APP_APIS}/${data.ItemKitHeader.DeleteItemKitHeader}`;
                    const response = await axios.post(url, formFields.ROWID, {
                        headers: {
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    if (response.data && response.data.Success) {
                        notify("Item Kit Header deleted successfully.", "success", 3000);
                        setformFields(initialFormFields);
                        setTimeout(() => {
                            history.push("/wm/codes/item-kit-codes");
                        }, 1000);
                    } else {
                        notify(response.data?.message || "Failed to delete Item Kit Header.", "error", 3000);
                    }
                } catch (error) {
                    const message = error?.response?.data?.message || error?.message || "An error occurred while deleting the Item Kit Header.";
                    notify(message, "error", 5000);
                } finally {
                    setLoadPanelVisible(false);
                }
            }
        });
    };

    const handleReset = () => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadItemKitHeaderById(rowId);
        } else {
            setformFields(initialFormFields);
        }
    };

    const goBack = () => {
        history.push("/wm/codes/item-kit-codes");
    };

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Item Kit Code
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.ROWID === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab 
                                        formFields={formFields} 
                                        setformFields={setformFields} 
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="Details" disabled={formFields.ROWID === '00000000-0000-0000-0000-000000000000'}>
                                    <DetailsTab 
                                        headerId={formFields.ROWID}
                                        customerId={formFields.R_CUSTOMER}
                                    />
                                </TabItem>
                            </TabPanel>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(Form);

